import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching day lessons
export const fetchDayLessons = createAsyncThunk(
  'dayLessons/fetchLessons',
  async (date, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) throw new Error("No authentication token found");

      const response = await axios.post(`${BASE_URL}/lessons/day_lessons`, {
        day: date // Format: "2025-08-14"
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });

      const data = response.data;

      if (data.status === "success") {
        return data.result;
      } else {
        return rejectWithValue(data.message || "حدث خطأ في جلب الحصص اليومية");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "حدث خطأ في جلب الحصص اليومية");
      } else if (error.message && error.message.toLowerCase().includes("network")) {
        return rejectWithValue("حدث خطأ في الاتصال بالخادم");
      } else {
        return rejectWithValue(error.message || "حدث خطأ غير متوقع");
      }
    }
  }
);

const initialState = {
  lessons: [],
  loading: false,
  error: null,
  selectedDate: null
};

const dayLessonsSlice = createSlice({
  name: 'dayLessons',
  initialState,
  reducers: {
    clearDayLessonsError: (state) => {
      state.error = null;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    clearLessons: (state) => {
      state.lessons = [];
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDayLessons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDayLessons.fulfilled, (state, action) => {
        state.loading = false;
        state.lessons = action.payload || [];
        state.error = null;
      })
      .addCase(fetchDayLessons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearDayLessonsError, setSelectedDate, clearLessons } = dayLessonsSlice.actions;
export default dayLessonsSlice.reducer;
